import axios from "axios";

// Always append /api programmatically so platform env resets can't break routing
const BASE_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/api\/?$/, "");
export const API = `${BASE_URL}/api`;

const BOARDROOM_TOKEN_KEY = "qcca_boardroom_token";

export const getBoardroomToken = () => {
  try {
    return localStorage.getItem(BOARDROOM_TOKEN_KEY);
  } catch (e) {
    console.warn('Failed to get boardroom token from localStorage:', e);
    return null;
  }
};

export const setBoardroomToken = (token) => {
  try {
    if (token) localStorage.setItem(BOARDROOM_TOKEN_KEY, token);
  } catch (e) {
    console.warn('Failed to save boardroom token to localStorage:', e);
  }
};

export const clearBoardroomToken = () => {
  try {
    localStorage.removeItem(BOARDROOM_TOKEN_KEY);
  } catch (e) {
    console.warn('Failed to clear boardroom token from localStorage:', e);
  }
};

const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = getBoardroomToken();
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

export default api;
